import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PipeWrenchIcon, TargetAdsIcon, MoneyBleedIcon } from './PlumbingIcons';
export function CredibilitySection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 px-4 bg-[#0a0a0a] relative z-10 border-y border-dark-card" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        <div className="text-center mb-16" data-id="element-64">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-65">
            Por qué el 90% de los plomeros fracasan en internet{' '}
            <br className="hidden md:block" data-id="element-66" />
            <span className="text-emerald" data-id="element-67">(Y cómo blindamos tu negocio)</span>
          </motion.h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto" data-id="element-68">
            No somos una agencia tradicional que te vende "likes" o
            "impresiones". Somos un quirófano de adquisición de clientes
            diseñado exclusivamente para servicios de emergencia.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-69">
          <motion.div variants={itemVariants} className="bg-dark p-8 rounded-2xl border border-emerald/20 hover:border-emerald/50 transition-colors" data-id="element-70">
            <div className="w-14 h-14 bg-emerald/10 rounded-full flex items-center justify-center mb-6" data-id="element-71">
              <TargetAdsIcon size={28} className="text-emerald" data-id="element-72" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-73">
              Exclusividad de Zona
            </h3>
            <p className="text-gray-400" data-id="element-74">
              Solo trabajamos con{' '}
              <span className="text-gold font-semibold" data-id="element-75">
                UN plomero por área geográfica
              </span>
              . Si te aceptamos, tus competidores quedan fuera. Todos los leads
              de tu zona son 100% tuyos.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-dark p-8 rounded-2xl border border-emerald/20 hover:border-emerald/50 transition-colors" data-id="element-76">
            <div className="w-14 h-14 bg-emerald/10 rounded-full flex items-center justify-center mb-6" data-id="element-77">
              <PipeWrenchIcon size={28} className="text-emerald" data-id="element-78" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-79">
              Leads de Alta Intención
            </h3>
            <p className="text-gray-400" data-id="element-80">
              Filtramos a los curiosos y a los que buscan precios baratos.
              Nuestro sistema atrae a personas con el agua hasta las rodillas
              que necesitan{' '}
              <span className="text-white font-semibold" data-id="element-81">
                ayuda inmediata, sin importar el precio
              </span>
              .
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-dark p-8 rounded-2xl border border-emerald/20 hover:border-emerald/50 transition-colors" data-id="element-82">
            <div className="w-14 h-14 bg-emerald/10 rounded-full flex items-center justify-center mb-6" data-id="element-83">
              <MoneyBleedIcon size={28} className="text-emerald" data-id="element-84" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-85">
              Retorno Predecible
            </h3>
            <p className="text-gray-400" data-id="element-86">
              Sabrás exactamente cuánto te cuesta adquirir un nuevo cliente.
              Transformamos tu presupuesto publicitario en una{' '}
              <span className="text-emerald font-semibold" data-id="element-87">
                máquina predecible de generación de ingresos
              </span>
              .
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}